import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// PrimeNG Imports
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';

import { ActivityType, ExcludeList, LeadsList, LinkedInSequence, Sender, SequenceStep, Template, TimeUnit, activityTypes, templates, timeUnits } from 'src/app/models/linkedin.model';
import { CheckboxModule } from 'primeng/checkbox';
import { Tooltip, TooltipModule } from 'primeng/tooltip';
import { SelectModule } from 'primeng/select';
import { LinkedInService } from 'src/app/services/linkedin.service';


@Component({
  selector: 'app-new-linkedin-sequence',
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    SelectModule,
    ButtonModule,
    InputNumberModule,
    InputSwitchModule,
    CheckboxModule,
    TooltipModule
  ],
  standalone: true,
  templateUrl: './new-linkedin-sequence.component.html',
  styleUrl: './new-linkedin-sequence.component.scss'
})
export class NewLinkedinSequenceComponent implements OnInit{
  @Input()
  completeCallback?: (data: any) => void;
  @Input()
  cancelCallback?: () => void;
  @Input()
  templates: Template[] = [];  
  @Input()
  leadsLists: LeadsList[] = [];
  @Input()
  excludeLists: ExcludeList[] = [];
  @Input()
  companyId: string = '';

  sequenceName: string = '';
  description: string = '';

  // Lead list selection
  selectedLeadsList?: LeadsList;
  selectedExcludeList?: ExcludeList;

  // Exclude options
  excludeFromOtherHeyReachCampaign: boolean = false;
  excludeMessagedByOtherSenders: boolean = false;
  excludeContactedBySameSender: boolean = false;

  steps: SequenceStep[] = [];
  nextStepId: number = 1;
  timeUnits: TimeUnit[] = []
  selectedSender?: Sender | null = null;
  senders: Sender[] = [];
  activityTypes: ActivityType[] = [];
  
  constructor(
    private linkedinService: LinkedInService
  ) {
    // Add initial step
    this.addStep();
  }
  async ngOnInit(): Promise<void> {
    console.log(this.leadsLists);
    
    if (this.companyId) {
      try {
        // GET /prospects/senders answers { success, data: [...] }
        const response = await this.linkedinService.getLinkedinAccounts(this.companyId);
        this.senders = Array.isArray(response?.data) ? response.data : [];
      } catch (error) {
        console.error('Could not load LinkedIn sender accounts:', error);
        this.senders = [];
      }
    }
  }

  addStep(): void {
    this.timeUnits = timeUnits;

    this.activityTypes = activityTypes;
    const newStep: SequenceStep = {
      id: this.nextStepId++,
      activityType: this.activityTypes[0], // Default to Message
      template: this.templates[0], // Default to Select template
      waitDuration: 1,
      waitUnit: this.timeUnits[0], // Default to Days
      enableABTesting: false,
      variantBContent: ''
    };
    this.steps.push(newStep);
  }

  removeStep(stepId: number): void {
    this.steps = this.steps.filter(step => step.id !== stepId);
  }

  // Method to handle leads list selection change
  onLeadsListChange(): void {
    if (this.selectedLeadsList?.linkedInAccountId) {
      this.updateSelectedSender(this.selectedLeadsList.linkedInAccountId);
    }
  }

  // Method to update selected sender based on ID
  private updateSelectedSender(linkedInAccountId: string): void {
    console.log(this.senders);
    
    this.selectedSender = this.senders.find(sender => sender.id.toString() == linkedInAccountId) || null;
    console.log('sender ', this.selectedSender);
    
  }
  

  onCancel(): void {
    //@ts-ignore
    this.cancelCallback();    
  }

  onCreateSequence(): void {
    const sequenceData: LinkedInSequence = {
      name: this.sequenceName,
      description: this.description,
      steps: this.steps,
      provider:'linkedin',
      sender:this.selectedSender,
      selectedLeadsList: this.selectedLeadsList,
      selectedExcludeList: this.selectedExcludeList,
      excludeOptions: {
        excludeFromOtherHeyReachCampaign: this.excludeFromOtherHeyReachCampaign,
        excludeMessagedByOtherSenders: this.excludeMessagedByOtherSenders,
        excludeContactedBySameSender: this.excludeContactedBySameSender
      }
    };
    //@ts-ignore
    this.completeCallback(sequenceData);
  }
}

